import SettingsLayout from "./Settings/SettingsLayout";

export default function FiskalyController() {
  return <SettingsLayout />;
}
